






import Vue from "vue";

export default Vue.extend({
    methods: {},
    created() {},
    mounted() {},
    watch: {
        $route: {
            handler(newRoute, oldRoute) {
                if (newRoute.query.channelCode) {
                    sessionStorage.setItem("channelCode", newRoute.query.channelCode);
                }
                if (localStorage.getItem("phone")) {
                    // 登录后刷新页面报考信息要重新选择
                    if (
                        (newRoute.path.includes("registration") || (newRoute.path.includes("nopayOrder") && !newRoute.query.orderId)) && !this.$store.state.auth.studentInfo
                    ) {
                        this.$router.push("/home");
                    }
                } else if (!localStorage.getItem("phone") && oldRoute.name) {
                    this.$router.push("/home");
                }
                document.body.style.overflow = "unset";
            },
            deep: true,
            immediate: true,
        },
    },
});
